import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import App from "./App";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
import ForgotPassword from "./ForgotPassword";

const Router = () => (
  <Routes>
    <Route path="/" element={<App />}></Route>
    <Route path="login" element={<Login slip />} />
    <Route path="login/sla" element={<Login />} />
    <Route path="auth/callback" element={<Login />} />
    <Route path="reset-password" element={<ResetPassword />} />
    <Route path="reset-password/:username/:userType/:token" element={<ResetPassword fromEmail />} />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="*" element={<Navigate replace to="/" />} />
  </Routes>
);

export default Router;
